import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { color, status } from "../redux/filter/action";

export default function Footer() {
  const todos = useSelector((state) => state.todo);
  const filters = useSelector((state) => state.filter);
  const { colors } = filters;
  const dispatch = useDispatch();
  const incompleteTask = todos.filter((data) => !data.completed).length;

  const colorChaker = (col) => {
    if (colors.includes(col)) {
      dispatch(color(col, "removed"));
    } else {
      dispatch(color(col, "added"));
    }
    console.log(colors);
  };

  console.log(filters);
  return (
    <div class="mt-2 flex justify-between text-xs text-gray-500">
      <p>{incompleteTask} tasks left</p>
      <ul class="flex space-x-1 items-center text-xs">
        <li></li>
        <li></li>
        <li
          onClick={() => colorChaker("green")}
          class={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
            colors.includes("green") && "bg-green-500"
          } `}
        ></li>
        <li
          onClick={() => colorChaker("red")}
          class={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
            colors.includes("red") && "bg-red-500"
          }`}
        ></li>
        <li
          onClick={() => colorChaker("yellow")}
          class={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
            colors.includes("yellow") && "bg-yellow-500"
          }`}
        ></li>
      </ul>
    </div>
  );
}
